import { render } from "./techArtMuseum.vue?vue&type=template&id=2f78e833&scoped=true"
import script from "./techArtMuseum.vue?vue&type=script&lang=js"
export * from "./techArtMuseum.vue?vue&type=script&lang=js"

import "./techArtMuseum.vue?vue&type=style&index=0&id=2f78e833&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f78e833"]])

export default __exports__